"use client";
import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { TableHeadContext } from "./THead.context.js";
import { tHeadVariants } from "./THead.variants.js";
import { cleanTableProps } from "../cleanTableProps.js";
import { useTableContext } from "../Table/index.js";
import { cn } from "../../../utils/index.js";
function THead({ children, className, ...props }) {
    const { headerSticky: tableHeaderSticky } = useTableContext();
    const { sticky: tableHeadSticky, interactive, striped, cellLineClamp, cellMaxWidth, cellSize, cellTextWrap, cellWordBreak, color, isGroupHeader } = props;
    const sticky = tableHeadSticky ?? tableHeaderSticky;
    const classes = cn(tHeadVariants({
        ...props,
        sticky
    }), className);
    const cleanedProps = cleanTableProps(props);
    const tableHeadContextValue = useMemo(()=>({
            sticky: tableHeadSticky,
            interactive,
            striped,
            cellLineClamp,
            cellMaxWidth,
            cellSize,
            cellTextWrap,
            cellWordBreak,
            color,
            isGroupHeader,
            isHeaderRow: true
        }), [
        tableHeadSticky,
        interactive,
        striped,
        cellLineClamp,
        cellMaxWidth,
        cellSize,
        cellTextWrap,
        cellWordBreak,
        color,
        isGroupHeader
    ]);
    return /*#__PURE__*/ jsx(TableHeadContext.Provider, {
        value: tableHeadContextValue,
        children: /*#__PURE__*/ jsx("thead", {
            className: classes,
            ...cleanedProps,
            children: children
        })
    });
}
export { THead };
